module.exports = __webpack_public_path__ + "img/safe-bg.53bea3a6.png";